import { ChangeEvent, useState } from 'react'
import { PointCardExpiration, PointCardExpirationType } from 'types/pointCard'
import { FirebaseTimestamp } from 'firebase/index'

const usePointCardExpiration = () => {
  const [expirationType, setExpirationType] = useState<PointCardExpirationType>('no_limit')
  const [expiration, setExpiration] = useState<PointCardExpiration | null>(null)

  const handleExpirationType = (type: PointCardExpirationType) => {
    setExpirationType(type)
    switch (type) {
      case 'no_limit':
        setExpiration(null)
        break
      case 'specified_date':
        setExpiration({
          expires_at: FirebaseTimestamp.now(),
          expiration_unit: null,
          expiration_period: null,
        })
        break
      case 'from_last_acquired_point_date':
        setExpiration({
          expires_at: null,
          expiration_unit: 'day',
          expiration_period: 180,
        })
        break
      case 'from_acquired_date':
        setExpiration({
          expires_at: null,
          expiration_unit: 'day',
          expiration_period: 180,
        })
        break
      default:
        break
    }
  }

  const handleExpiresAt = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setExpiration((prevState) => {
      if (prevState) {
        return {
          ...prevState,
          expires_at: FirebaseTimestamp.fromDate(new Date(value)),
        }
      }
      return prevState
    })
  }

  // 相対日数の変更
  const handleExpirationPeriod = (value: string) => {
    if (!/^[0-9]*$/.test(value)) return
    setExpiration({
      expires_at: null,
      expiration_unit: 'day',
      expiration_period: parseInt(value),
    })
  }

  return {
    expiration,
    expirationType,
    handleExpirationType,
    handleExpiresAt,
    handleExpirationPeriod,
    setExpiration,
    setExpirationType,
  }
}

export default usePointCardExpiration
